import React, { useState, useLayoutEffect } from 'react'
import api from '../api'

import { Button, Input, Space, Table, Alert, Typography, message, Tag } from 'antd'

import { ProCard, CheckCard } from '@ant-design/pro-components'

// import Alipay from 'https://i.n2yun.com.cn/cdn/n2_web/20240904/static/media/alipay.fb7960d688e287342a6f.png'
// import Wxpay from '../../images/wxpay.png'

const { Title, Paragraph } = Typography

//  表格
const columns = [
    {
        title: '订单ID',
        dataIndex: '_id',
        key: '_id',
    },
    {
        title: '产品类型',
        dataIndex: 'label',
        key: 'label',
        render: ((label) => {
            return (
                <>{label}</>
            )
        })
    },
    {
        title: '套餐',
        dataIndex: 'PlansObj',
        key: 'PlansObj',
        render: ((PlansObj) => {
            return (
                <>{PlansObj.chinese} #{PlansObj.duration}个月</>
            )
        })
    },
    {
        title: '状态',
        dataIndex: 'state',
        key: 'state',
        render: ((state) => {
            let Data = parseInt(state)
            if (Data === 0) {
                return (
                    <Tag color="warning">待处理</Tag>
                )
            }
            if (Data === 1) {
                return (
                    <Tag color="processing">已锁定, 人工正在开通</Tag>
                )
            }
            if (Data === 101) {
                return (
                    <Tag color="processing">已锁定, 系统正在开通</Tag>
                )
            }
            if (Data === 102 || Data === 103 || Data === 104) {
                return (
                    <Tag color="warning">系统无法处理, 等待人工介入</Tag>
                )
            }
            if (Data === 2) {
                return (
                    <Tag color="success">已开通</Tag>
                )
            }
            if (Data === 3) {
                return (
                    <Tag color="error">已退款</Tag>
                )
            }
        }),
    },
    // {
    //     title: '优惠券号码',
    //     dataIndex: 'number',
    //     key: 'number',
    //     render: ((number) => {
    //         return (
    //             <Paragraph
    //                 copyable={{
    //                     text: number,
    //                 }}
    //             >
    //                 {number}
    //             </Paragraph>
    //         )
    //     }),
    // },
    {
        title: '实付金额',
        dataIndex: 'PlansObj',
        key: 'PlansObj',
        render: ((PlansObj) => {
            return (
                <>{PlansObj.price}</>
            )
        })
    },
    {
        title: '购买时间',
        dataIndex: 'ctime',
        key: 'ctime',
        render: ((ctime) => {
            return (
                <>
                    <div>
                        {ctime}
                    </div>
                    {/* <div>
                        {ctime}
                    </div> */}
                </>
            )
        })
    },

    // {
    //     title: '开通时间',
    //     dataIndex: 'ctime',
    //     key: 'ctime',
    // },
    // {
    //     title: '到期时间',
    //     dataIndex: 'ctime',
    //     key: 'ctime',
    // },
];

//  控制台-订单中心
function Order(props) {
    const [data, setData] = useState({ order: [] })

    useLayoutEffect(() => {
        api.post('/api/v2/pay_v2', {
            type: 'get_owner_users_order',
        })
            .then((res) => {
                if (res.data.code === 200) {
                    setData(res.data.data.data)
                    // message.success('成功获取数据')
                } else {
                    message.error(res.data.data.text)
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器')
            })
    }, [])

    function onClick(name) {

    }

    return (
        <div>
            <Alert
                message="欢迎使用订单中心"
                description="在这里可以查询您已购买产品的相关信息, 以便及时了解产品开通进度, 关于存储块产品完成开通后可前往 开放平台/NZ云存储 V2 进行使用!"
                showIcon
                style={{ marginBottom: 20 }}
            />

            <props.clear />
            <Title level={4}>已购买产品</Title>
            <Table
                columns={columns}
                dataSource={data.order}
                pagination={false}
                style={{
                    marginTop: 20
                }}
            />
        </div>
    )
}

export default Order;